import { UnControlled as CodeMirror } from "react-codemirror2";
import ContentPadding from "../ContentConfig/ContentPadding";
import { Divider, Form } from "antd";
import "codemirror/lib/codemirror.css";
import "codemirror/theme/seti.css";
import "codemirror/mode/xml/xml";
import { useMemo } from "react";
import ContentID from "../Common/ContentID";

const CodeMirrorWrapper = ({ onChange, value }) => {
  const initVal = useMemo(() => value, []);
  return (
    <div style={{border: "1px solid #ccc"}}>
      <CodeMirror
        value={initVal}
        onChange={(_, __, value) => {
          onChange(value);
        }}
        options={{
          mode: "xml",
          htmlMode: true,
        }}
      />
    </div>
  );
};

export default () => {
  return (
    <>
      <Form.Item label="HTML" name="html">
        <CodeMirrorWrapper />
      </Form.Item>
      <Divider />
      <ContentID />
      <ContentPadding />
    </>
  );
};
